import React from "react";
import { bind } from "decko";

export default class MatchInfoOverlay extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            clips: null,
        }
    }

    componentWillUnmount () {
        this.mounted = false;
    }

    componentDidMount () {
        this.mounted = true;
        this.load();
    }

    @bind
    load () {
        const {game, server} = this.props;
        if (!game) return;
        const params = { min_rating: 4, count: 999, nocache: true };
        const url = server.createUrl("/game/" + game.id + "/events", params)
        server.get(url, data => {
            if (this.mounted) this.setState({clips: data.events});
        });
    }

    @bind
    forceRefresh () {
        this.load();
    }

    render () {

        let game = this.props.game;
        if (!game) return null;

        let nearLiveRow = null;
        const clips = this.state.clips;
        if (clips !== null) {
            const maxNearLiveSeconds = 360;
            const nearLiveClips = clips.length;
            const nearLiveSeconds = clips.reduce((acc, e) => acc + e.playlist.duration_ms, 0) / 1000;
            const secUsedClass = (nearLiveSeconds > maxNearLiveSeconds) ? "match-info-invalid" : "";

            nearLiveRow = (
                <tr>
                    <td>{nearLiveClips} H+ clips</td>
                    <td className={secUsedClass}>{nearLiveSeconds.toFixed(0)} / {maxNearLiveSeconds} sec </td>
                </tr>
            );
        }

        const d = new Date(game.start_time);
        const hours = d.getHours().toString(10).padStart(2, "0");
        const minutes = d.getMinutes().toString(10).padStart(2, "0");
        const title = `${game.home_team.name} v ${game.visiting_team.name} (${hours}:${minutes})`;
        const score = `${game.home_team_goals} - ${game.visiting_team_goals}`;
        const state = game.phase;

        return (
            <div className="transparent-black-bg text-outline match-info-overlay">
                <table>
                    <thead>
                        <tr><th colSpan="2">{title}</th></tr>
                    </thead>
                    <tbody>
                        <tr><td>{state}</td><td>{score}</td></tr>
                        {nearLiveRow}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/MatchInfoOverlay.js